import { t } from '@lingui/core/macro';

import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';

import CampaignOverviewActions from './CampaignOverviewActions';
import CampaignOverviewContent from './CampaignOverviewContent';

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 20,
  sortBy: 'visits',
  sortOrder: InstantSearchSortOrder.DESC,
};

const CampaignOverview = () => {
  return (
    <Page
      title={t`Campaigns`}
      pageName={t`All Campaigns`}
      exampleAIQuestions={exampleAIQuestions('campaign')}
    >
      <InstantSearch prefix="c" defaultQueryState={DEFAULT_QUERY_STATE}>
        <PageFilterProvider>
          <div className="flex w-full flex-col gap-6">
            <div className="flex justify-between">
              <PageDateRangeFilter />
              <CampaignOverviewActions />
            </div>
            <CampaignOverviewContent />
          </div>
        </PageFilterProvider>
      </InstantSearch>
    </Page>
  );
};

export default CampaignOverview;
